module.exports = __webpack_public_path__ + "static/media/MyriadPro-Regular.4dc5956a.otf";